import { useContext } from "react"
import Contexto from "../../Contexts/Sesion/Ctx"

const useSesion=()=>{
    const sesion = useContext(Contexto)
    return sesion
}

export default useSesion